import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import Avatar from "@/components/Avatar.vue";
let TechnicianCard = class TechnicianCard extends Vue {
    name = 'Technician';
    description = 'Technician card for display info';
    technician;
};
__decorate([
    Prop({ required: true, type: Object })
], TechnicianCard.prototype, "technician", void 0);
TechnicianCard = __decorate([
    Component({
        name: "TechnicianCard",
        components: {
            Avatar,
        },
    })
], TechnicianCard);
export default TechnicianCard;
